import { liveRadios } from './liveRadios';

export interface LiveHost {
  id: number;
  name: string;
  photoUrl: string;
  programName: string;
  programSlug: string;
  radioName: string;
  radioFrequency: string;
  radioSlug: string;
  role: string;
  followers: number;
  activityScore: number;
}

function buildLiveHosts(): LiveHost[] {
  const result: LiveHost[] = [];
  const seen = new Set<string>();

  for (const radio of liveRadios) {
    const prog = radio.programs[0];
    const freqSlug = radio.frequency.replace(/[.\s]+FM$/g, '').replace(/\./g, '-');
    const programSlug = prog?.name?.toLowerCase().replace(/\s+/g, '-') || '';

    for (const bc of radio.broadcasters) {
      if (seen.has(bc.name)) continue;
      seen.add(bc.name);

      const baseFollowers = Math.floor(Math.random() * 280000) + 15000;

      result.push({
        id: bc.id,
        name: bc.name,
        photoUrl: bc.photoUrl,
        programName: prog?.name || '',
        programSlug,
        radioName: radio.name,
        radioFrequency: radio.frequency,
        radioSlug: freqSlug,
        role: bc.role,
        followers: baseFollowers,
        activityScore: radio.activityScore,
      });
    }
  }

  return result;
}

export const liveHosts: LiveHost[] = buildLiveHosts();

export const liveHostsStats = {
  totalHosts: liveHosts.length,
  totalFollowers: liveHosts.reduce((s, h) => s + h.followers, 0),
  totalRadios: liveRadios.length,
  onAirCount: liveRadios.filter(r => r.status === 'on-air').length,
  liveShowCount: liveRadios.filter(r => r.status === 'live-show').length,
};

export type HostSortMode = 'activity' | 'followers' | 'name';